//src/pages/PainelCliente/TikpagExperienceCliente.jsx

import React, {
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";

import { useNavigate } from "react-router-dom";

import {
  Award,
  CalendarDays,
  CheckCircle2,
  ChevronRight,
  Gift,
  LockKeyhole,
  Medal,
  RefreshCcw,
  Rocket,
  Sparkles,
  Trophy
} from "lucide-react";

import {
  getPinImage,
  getPinThemeClass
} from "../../utils/pinAssets";

import axios from "../../axiosConfig";
import "./TikpagExperienceCliente.css";

const classePin = (pinOuCodigo) =>
  getPinThemeClass(pinOuCodigo);



const formatarDinheiro = (valor) =>
  Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL"
  });

const formatarData = (valor) => {
  if (!valor) return "-";

  const texto = String(valor).slice(0, 10);
  const [ano, mes, dia] = texto.split("-");

  if (!ano || !mes || !dia) return valor;

  return `${dia}/${mes}/${ano}`;
};

const formatarCompetencia = (ano, mes) =>
  new Intl.DateTimeFormat("pt-BR", {
    month: "long",
    year: "numeric"
  }).format(
    new Date(
      Number(ano),
      Number(mes) - 1,
      1
    )
  );



export default function TikpagExperienceCliente() {

  const navigate = useNavigate();
  
  const [campanhas, setCampanhas] =
    useState([]);

  const [campanhaId, setCampanhaId] =
    useState(null);

  const [detalhes, setDetalhes] =
    useState(null);

  const [jornada, setJornada] =
    useState(null);

  const [aceitouRegulamento, setAceitouRegulamento] =
    useState(false);

  const [regulamentoAberto, setRegulamentoAberto] =
    useState(false);

  const [loading, setLoading] =
    useState(true);

  const [inscrevendo, setInscrevendo] =
    useState(false);

  const [erro, setErro] =
    useState("");

  const [sucesso, setSucesso] =
    useState("");

  const [experienciasDestaque, setExperienciasDestaque] =
    useState([]);

  const carregarDetalhes = useCallback(
    async (id) => {
      if (!id) return;

      const resposta = await axios.get(
        `/experience/campanhas/${id}`
      );

      setDetalhes(resposta.data || null);

      return resposta.data;
    },
    []
  );

  const carregarJornada = useCallback(
    async (id) => {
      if (!id) return;

      try {
        const resposta = await axios.get(
          `/experience/minha-jornada/${id}`
        );

        setJornada(resposta.data || null);
      } catch (err) {
        if (
          err.response?.status === 403 &&
          err.response?.data?.precisa_inscricao
        ) {
          setJornada(null);
          return;
        }

        throw err;
      }
    },
    []
  );

  const carregarExperienciasDestaque =
  useCallback(async () => {
    try {
      const resposta = await axios.get(
        "/experience/vitrine"
      );

      const categorias =
        Array.isArray(
          resposta.data?.categorias
        )
          ? resposta.data.categorias
          : [];

      const todasExperiencias =
        categorias.flatMap(
          (categoria) =>
            Array.isArray(
              categoria.experiencias
            )
              ? categoria.experiencias
              : []
        );

      const comImagem =
        todasExperiencias.filter(
          (item) => item.imagem_url
        );

      const embaralhadas = [
        ...comImagem
      ].sort(
        () => Math.random() - 0.5
      );

      setExperienciasDestaque(
        embaralhadas.slice(0, 3)
      );
      } catch (err) {
        console.error(
          "Erro ao carregar destaques do Experience:",
          err
        );

        setExperienciasDestaque([]);
      }
      }, []);

  const carregarPagina = useCallback(async () => {
    setLoading(true);
    setErro("");

    try {
      const resposta = await axios.get(
        "/experience/campanhas"
      );

      const lista = Array.isArray(
        resposta.data?.campanhas
      )
        ? resposta.data.campanhas
        : [];

      setCampanhas(lista);

      const campanhaPreferencial =
        lista.find(
          (campanha) => campanha.inscrito
        ) || lista[0];

      if (!campanhaPreferencial) {
        setCampanhaId(null);
        setDetalhes(null);
        setJornada(null);
        return;
      }

      const id =
        Number(campanhaPreferencial.id);

      setCampanhaId(id);

      const detalhe =
        await carregarDetalhes(id);

      if (
        detalhe?.campanha?.inscrito
      ) {
        await carregarJornada(id);
      } else {
        setJornada(null);
      }
    } catch (err) {
      console.error(
        "Erro ao carregar Tikpag Experience:",
        err
      );

      setErro(
        err.response?.data?.error ||
          "Não foi possível carregar o Tikpag Experience."
      );
    } finally {
      setLoading(false);
    }
  }, [
    carregarDetalhes,
    carregarJornada
  ]);

  useEffect(() => {
      carregarPagina();
      carregarExperienciasDestaque();
    }, [
      carregarPagina,
      carregarExperienciasDestaque
    ]);

  const selecionarCampanha = async (id) => {
    const campanhaIdNumero =
      Number(id);

    setCampanhaId(
      campanhaIdNumero
    );

    setLoading(true);
    setErro("");
    setSucesso("");
    setAceitouRegulamento(false);

    try {
      const detalhe =
        await carregarDetalhes(
          campanhaIdNumero
        );

      if (
        detalhe?.campanha?.inscrito
      ) {
        await carregarJornada(
          campanhaIdNumero
        );
      } else {
        setJornada(null);
      }
    } catch (err) {
      setErro(
        err.response?.data?.error ||
          "Não foi possível carregar a campanha."
      );
    } finally {
      setLoading(false);
    }
  };

  const realizarInscricao = async () => {
  if (!campanhaId) return;

  if (!aceitouRegulamento) {
    setErro(
      "Você precisa ler e aceitar o regulamento para participar."
    );
    return;
  }

  setInscrevendo(true);
  setErro("");
  setSucesso("");

  try {
    await axios.post(
      `/experience/campanhas/${campanhaId}/inscrever`,
      {
        aceitou_regulamento: true,
        versao_regulamento: "1.0"
      }
    );

    /*
     * Depois que o backend confirma a inscrição,
     * colocamos a página em loading antes de
     * trocar toda a estrutura visual.
     *
     * Isso evita várias reconciliações sucessivas
     * do DOM durante a mudança de "não inscrito"
     * para "inscrito".
     */
    setLoading(true);

    const [
      respostaDetalhes,
      respostaJornada
    ] = await Promise.all([
      axios.get(
        `/experience/campanhas/${campanhaId}`
      ),

      axios.get(
        `/experience/minha-jornada/${campanhaId}`
      )
    ]);

    /*
     * Atualizamos os dados juntos enquanto a
     * tela de loading está sendo exibida.
     */
    setDetalhes(
      respostaDetalhes.data || null
    );

    setJornada(
      respostaJornada.data || null
    );

    setCampanhas((lista) =>
      lista.map((campanha) =>
        Number(campanha.id) ===
        Number(campanhaId)
          ? {
              ...campanha,
              inscrito: true
            }
          : campanha
      )
    );

    setAceitouRegulamento(false);

    setSucesso(
      "Inscrição realizada com sucesso. Sua jornada começou!"
    );
  } catch (err) {
    console.error(
      "Erro ao inscrever no Tikpag Experience:",
      err
    );

    setErro(
      err.response?.data?.error ||
        "Não foi possível realizar sua inscrição."
    );
  } finally {
    setLoading(false);
    setInscrevendo(false);
  }
};

  const campanha =
    detalhes?.campanha || null;

  const pins =
    Array.isArray(detalhes?.pins)
      ? detalhes.pins
      : [];

  const periodo =
    jornada?.periodo_atual || null;

  const progresso =
    jornada?.progresso || {};

  const conquistas =
    Array.isArray(jornada?.conquistas)
      ? jornada.conquistas
      : [];

  const estaInscrito =
    Boolean(campanha?.inscrito);

  const campanhaAindaNaoIniciou =
    Boolean(
      periodo &&
        periodo.campanha_iniciada ===
          false
    );

  const pinAtual =
    progresso.pin_atual || null;

  const proximoPin =
    progresso.proximo_pin || null;

  const percentual =
    Math.max(
      0,
      Math.min(
        100,
        Number(
          progresso.percentual || 0
        )
      )
    );

  const pinDestaque =
    pinAtual ||
    proximoPin ||
    pins[0] ||
    null;

  const imagemPinDestaque =
     getPinImage(pinDestaque);

  const temaHero =
    classePin(pinDestaque) ||
    "experience";

  const mensagemHero = useMemo(() => {
    if (!estaInscrito) {
        return (
          campanha?.descricao ||
          "Transforme suas operações em conquistas, PINs colecionáveis e experiências inesquecíveis."
        );
      }

    if (campanhaAindaNaoIniciou) {
      return `Sua jornada começa em ${formatarData(
        periodo?.data_inicio
      )}. Prepare-se para evoluir todos os meses.`;
    }

    if (
      pinAtual &&
      !proximoPin
    ) {
      return "Você alcançou o nível máximo desta competência. Uma conquista extraordinária.";
    }

    if (
      pinAtual &&
      proximoPin
    ) {
      return `Você conquistou o ${pinAtual.nome} e está avançando para o ${proximoPin.nome}.`;
    }

    return `Você está construindo sua jornada. O próximo destino é o PIN ${
      proximoPin?.nome || "Rocket"
    }.`;
  }, [
    estaInscrito,
    campanha,
    campanhaAindaNaoIniciou,
    periodo,
    pinAtual,
    proximoPin
  ]);

  const resumoMes = useMemo(() => {
    if (!periodo) return "-";

    return formatarCompetencia(
      periodo.ano,
      periodo.mes
    );
  }, [periodo]);

  const etapaAtual = useMemo(() => {
    if (!estaInscrito) return 0;
    if (campanhaAindaNaoIniciou) return 1;
    if (!conquistas.length) return 2;

    const conquistaAberta =
      conquistas.find(
        (item) =>
          item.status ===
          "AGUARDANDO_ESCOLHA"
      );

    if (conquistaAberta) return 3;

    const escolhaEmAndamento =
      conquistas.find(
        (item) =>
          item.escolha_id &&
          item.escolha_status !==
            "UTILIZADA"
      );

    if (escolhaEmAndamento) return 4;

    return 5;
  }, [
    estaInscrito,
    campanhaAindaNaoIniciou,
    conquistas
  ]);

  if (loading) {
    return (
      <div className="experienceCliente-page">
        <div className="experienceCliente-loading">
          <RefreshCcw
            size={28}
            className="experienceCliente-spin"
          />

          <strong>
            Carregando sua jornada...
          </strong>
        </div>
      </div>
    );
  }

  if (!campanha) {
    return (
      <div className="experienceCliente-page">
        <section className="experienceCliente-empty">
          <Sparkles size={34} />

          <h1>Tikpag Experience</h1>

          <p>
            Nenhuma campanha está disponível
            neste momento.
          </p>
        </section>
      </div>
    );
  }

  return (
    <div className="experienceCliente-page">
      {campanhas.length > 1 && (
        <div className="experienceCliente-campaignSelector">
          <span>Campanha</span>

          <select
            value={campanhaId || ""}
            onChange={(event) =>
              selecionarCampanha(
                event.target.value
              )
            }
          >
            {campanhas.map(
              (item) => (
                <option
                  key={item.id}
                  value={item.id}
                >
                  {item.nome}
                </option>
              )
            )}
          </select>
        </div>
      )}

      {erro && (
        <div className="experienceCliente-alert erro">
          {erro}
        </div>
      )}

      {sucesso && (
        <div className="experienceCliente-alert sucesso">
          <CheckCircle2 size={17} />
          {sucesso}
        </div>
      )}

      <section
        className={`experienceCliente-hero experienceCliente-hero--premium experienceCliente-hero--${temaHero}`}
        style={
          campanha.imagem_banner
            ? {
                backgroundImage: `linear-gradient(120deg, rgba(15, 23, 42, .95), rgba(76, 29, 149, .84)), url("${campanha.imagem_banner}")`
              }
            : undefined
        }
      >
        <div className="experienceCliente-starField" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>

        <div className="experienceCliente-heroGlow" />
        <div className="experienceCliente-heroOrbit experienceCliente-heroOrbit--one" />
        <div className="experienceCliente-heroOrbit experienceCliente-heroOrbit--two" />

        <div className="experienceCliente-heroContent">
          <span className="experienceCliente-kicker">
            Programa oficial Tikpag
          </span>

          <h1>{campanha.nome}</h1>

          <p className="experienceCliente-heroLead">
            {mensagemHero}
          </p>

          {estaInscrito && (
            <>
              <div className="experienceCliente-heroStats">
                <div>
                  <span>Volume atual</span>
                  <strong>
                    {formatarDinheiro(
                      periodo?.volume_apurado
                    )}
                  </strong>
                </div>

                <div>
                  <span>PIN atual</span>
                  <strong>
                    {pinAtual
                      ? pinAtual.nome
                      : "Em evolução"}
                  </strong>
                </div>

                <div>
                  <span>
                    {proximoPin
                      ? "Próxima meta"
                      : "Temporada"}
                  </span>
                  <strong>
                    {proximoPin
                      ? formatarDinheiro(
                          progresso.falta_para_proximo
                        )
                      : "Nível máximo"}
                  </strong>
                </div>
              </div>

              <div className="experienceCliente-heroProgress">
                <div className="experienceCliente-heroProgressHeader">
                  <span>
                    Evolução para{" "}
                    {proximoPin?.nome ||
                      pinAtual?.nome ||
                      "Rocket"}
                  </span>

                  <strong>
                    {Math.round(percentual)}%
                  </strong>
                </div>

                <div className="experienceCliente-heroProgressTrack">
                  <span
                    style={{
                      width: `${percentual}%`
                    }}
                  />
                </div>
              </div>
            </>
          )}

          <div className="experienceCliente-heroMeta">
            <span>
              <CalendarDays size={15} />
              {formatarData(
                campanha.data_inicio
              )}
              {" a "}
              {formatarData(
                campanha.data_fim
              )}
            </span>

            <span>
              <Award size={15} />
              Apuração mensal
            </span>

            <span>
              <Gift size={15} />
              Experiências exclusivas
            </span>

            <button
            type="button"
            className="experienceCliente-heroRegulation"
            onClick={() =>
              setRegulamentoAberto(true)
            }
          >
            <LockKeyhole size={15} />
            Ver regulamento
          </button>

          </div>
        </div>

        <div className="experienceCliente-emblemWrap">
          <div
            className={`experienceCliente-emblem ${classePin(
              pinDestaque?.codigo
            )}`}
          >
            <div className="experienceCliente-emblemHalo" />
            <div className="experienceCliente-emblemPulse" />
            <div className="experienceCliente-emblemRing experienceCliente-emblemRing--one" />
            <div className="experienceCliente-emblemRing experienceCliente-emblemRing--two" />

            <div className="experienceCliente-emblemInner">
                {imagemPinDestaque ? (
                  <img
                    src={imagemPinDestaque}
                    alt={`PIN ${pinDestaque?.nome || ""}`}
                  />
                ) : (
                  <Medal size={54} />
                )}
            </div>
          </div>

          <span>
            {pinAtual
              ? "PIN conquistado"
              : "Próximo PIN"}
          </span>

          <strong>
            {pinDestaque?.nome ||
              "Tikpag Experience"}
          </strong>

          {estaInscrito &&
            proximoPin && (
              <small>
                Faltam{" "}
                {formatarDinheiro(
                  progresso.falta_para_proximo
                )}
              </small>
            )}
        </div>
      </section>

      <section className="experienceCliente-inspire">
          <div className="experienceCliente-inspireContent">
            <span className="experienceCliente-inspireKicker">
              <Sparkles size={15} />
              Inspire-se
            </span>

            <h2>
              Experiências que valem a conquista.
            </h2>

            <p>
              Transforme seus resultados em momentos
              especiais. Cinema, gastronomia,
              entretenimento, presentes e muito mais
              esperam por você no Tikpag Experience.
            </p>

            <button
              type="button"
              className="experienceCliente-inspireButton"
              onClick={() =>
                navigate(
                  "/painel-cliente/tikpag-experience/experiencias"
                )
              }
            >
              <Gift size={17} />
              Explorar experiências
              <ChevronRight size={17} />
            </button>
          </div>

          <div className="experienceCliente-inspireGallery">
            {experienciasDestaque.map(
              (experiencia, indice) => (
                <button
                  type="button"
                  key={experiencia.id}
                  className={`experienceCliente-inspirePhoto experienceCliente-inspirePhoto--${indice + 1}`}
                  onClick={() =>
                    navigate(
                      "/painel-cliente/tikpag-experience/experiencias"
                    )
                  }
                  aria-label={`Ver ${experiencia.titulo}`}
                >
                  <img
                    src={experiencia.imagem_url}
                    alt={experiencia.titulo}
                  />

                  <span>
                    {experiencia.pin?.nome ||
                      "Experience"}
                  </span>
                </button>
              )
            )}

            {!experienciasDestaque.length && (
              <div className="experienceCliente-inspirePlaceholder">
                <Gift size={36} />

                <span>
                  Descubra suas próximas
                  experiências
                </span>
              </div>
            )}
          </div>
        </section>

      {!estaInscrito ? (
        <>
          <section className="experienceCliente-introGrid">
            <article className="experienceCliente-introCard">
              <div className="experienceCliente-introIcon">
                <Rocket size={22} />
              </div>

              <h2>Cadastre suas operações</h2>

              <p>
                Continue cadastrando normalmente
                suas operações aprovadas no
                Tikpontos.
              </p>
            </article>

            <article className="experienceCliente-introCard">
              <div className="experienceCliente-introIcon">
                <Medal size={22} />
              </div>

              <h2>Conquiste seu PIN</h2>

              <p>
                Ao final de cada mês, o sistema
                identifica o maior nível atingido.
              </p>
            </article>

            <article className="experienceCliente-introCard">
              <div className="experienceCliente-introIcon">
                <Gift size={22} />
              </div>

              <h2>Escolha sua experiência</h2>

              <p>
                Depois da apuração, escolha uma
                experiência disponível para sua
                conquista.
              </p>
            </article>
          </section>

          <section className="experienceCliente-panel experienceCliente-collectionShowcase">
            <div className="experienceCliente-panelHeader">
              <div>
                <span>
                  Sua jornada
                </span>

                <h2>
                  Conheça os PINs
                </h2>

                <p>
                  Atingindo a meta mensal, você
                  recebe apenas o maior PIN
                  conquistado naquele mês.
                </p>
              </div>
            </div>

            <div className="experienceCliente-pinsGrid">
              {pins.map((pin) => (
                <article
                  className={`experienceCliente-pinCard ${classePin(pin)}`}
                  key={pin.id}
                >
                  <div className="experienceCliente-pinImage">
                    {getPinImage(pin) ? (
                      <img
                        src={getPinImage(pin)}
                        alt={`PIN ${pin.nome}`}
                      />
                    ) : (
                      <Medal size={28} />
                    )}
                  </div>

                  <span>
                    Nível {pin.ordem}
                  </span>

                  <h3>{pin.nome}</h3>

                  <strong>
                    {formatarDinheiro(
                      pin.valor_minimo
                    )}
                  </strong>

                  <p>
                    {pin.descricao ||
                      "PIN mensal colecionável e acesso às experiências desta categoria."}
                  </p>
                </article>
              ))}
            </div>
          </section>

          <section className="experienceCliente-enrollment">
            <div>
              <span className="experienceCliente-kicker dark">
                Faça parte
              </span>

              <h2>
                Comece sua jornada no
                Tikpag Experience
              </h2>

              <p>
                Leia o regulamento e confirme sua
                participação. A inscrição é
                necessária para que suas operações
                sejam consideradas.
              </p>
            </div>

            <div className="experienceCliente-enrollmentAction">
              <button
                type="button"
                className="experienceCliente-regulationButton"
                onClick={() =>
                  setRegulamentoAberto(true)
                }
              >
                Ler regulamento
                <ChevronRight size={16} />
              </button>

              <label className="experienceCliente-accept">
                <input
                  type="checkbox"
                  checked={
                    aceitouRegulamento
                  }
                  onChange={(event) =>
                    setAceitouRegulamento(
                      event.target.checked
                    )
                  }
                />

                <span>
                  Li e aceito o regulamento da
                  campanha.
                </span>
              </label>

              <button
                type="button"
                className="experienceCliente-primaryButton"
                onClick={realizarInscricao}
                disabled={
                  inscrevendo ||
                  !aceitouRegulamento
                }
              >
                {inscrevendo ? (
                  <RefreshCcw
                    size={17}
                    className="experienceCliente-spin"
                  />
                ) : (
                  <Sparkles size={17} />
                )}

                Quero participar
              </button>
            </div>
          </section>
        </>
      ) : (
        <>
          {campanhaAindaNaoIniciou && (
            <section className="experienceCliente-startNotice">
              <LockKeyhole size={22} />

              <div>
                <span>
                  Inscrição confirmada
                </span>

                <h2>
                  A campanha começa em{" "}
                  {formatarData(
                    periodo.data_inicio
                  )}
                </h2>

                <p>
                  Seu progresso será calculado
                  automaticamente a partir do
                  início da campanha.
                </p>
              </div>
            </section>
          )}

          <section className="experienceCliente-progressExperience">
            <div className="experienceCliente-progressExperienceHeader">
              <div>
                <span>Progresso do mês</span>
                <h2>{resumoMes}</h2>
              </div>

              <strong>
                {Math.round(percentual)}%
              </strong>
            </div>

            <div className="experienceCliente-levelTrack">
              <div className="experienceCliente-levelLine">
                <span
                  style={{
                    width: `${percentual}%`
                  }}
                />
              </div>

              <div className="experienceCliente-levelNodes">
                {pins.map((pin) => {
                  const atingido =
                    Number(
                      periodo?.volume_apurado || 0
                    ) >=
                    Number(
                      pin.valor_minimo || 0
                    );

                  const atual =
                    pinAtual?.id ===
                    pin.id;

                  return (
                    <div
                      className={`experienceCliente-levelNode ${
                        atingido
                          ? "atingido"
                          : ""
                      } ${
                        atual
                          ? "atual"
                          : ""
                      }`}
                      key={pin.id}
                    >
                      <div>
                        {getPinImage(pin) ? (
                          <img
                            src={getPinImage(pin)}
                            alt={`PIN ${pin.nome}`}
                          />
                        ) : (
                          <Medal size={18} />
                        )}
                      </div>

                      <span>{pin.nome}</span>
                      <small>
                        {formatarDinheiro(
                          pin.valor_minimo
                        )}
                      </small>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="experienceCliente-nextMission">
              <div>
                <span>Próxima missão</span>
                <h3>
                  {proximoPin
                    ? proximoPin.nome
                    : "Maior nível conquistado"}
                </h3>
              </div>

              <div>
                <span>Quanto falta</span>
                <strong>
                  {proximoPin
                    ? formatarDinheiro(
                        progresso
                          .falta_para_proximo
                      )
                    : "Meta máxima"}
                </strong>
              </div>
            </div>
          </section>

          <section className="experienceCliente-missionTimeline">
            {[
              "Inscrição",
              "Operações",
              "Apuração",
              "Escolha",
              "Experiência"
            ].map((etapa, indice) => {
              const concluida =
                indice < etapaAtual;
              const atual =
                indice === etapaAtual;

              return (
                <div
                  className={`experienceCliente-missionStep ${
                    concluida
                      ? "concluida"
                      : ""
                  } ${
                    atual
                      ? "atual"
                      : ""
                  }`}
                  key={etapa}
                >
                  <div>
                    {concluida ? (
                      <CheckCircle2
                        size={18}
                      />
                    ) : atual ? (
                      <Sparkles size={18} />
                    ) : (
                      <span />
                    )}
                  </div>

                  <strong>{etapa}</strong>
                </div>
              );
            })}
          </section>

          <section className="experienceCliente-panel">
            <div className="experienceCliente-panelHeader">
              <div>
                <span>
                  Minha coleção
                </span>

                <h2>
                  PINs conquistados
                </h2>

                <p>
                  Cada fechamento mensal pode
                  adicionar uma nova conquista à
                  sua coleção.
                </p>
              </div>
            </div>

            {conquistas.length ? (
              <div className="experienceCliente-collectionGrid">
                {conquistas.map(
                  (conquista) => (
                    <article
                      className="experienceCliente-collectionCard experienceCliente-collectionCard--premium"
                      key={conquista.id}
                    >
                      <div className="experienceCliente-collectionPin">
                          {getPinImage(conquista) ? (
                            <img
                              src={getPinImage(conquista)}
                              alt={`PIN ${conquista.pin_nome}`}
                            />
                          ) : (
                            <Trophy size={34} />
                          )}
                      </div>

                      <span>
                        {formatarCompetencia(
                          conquista.ano,
                          conquista.mes
                        )}
                      </span>

                      <h3>
                        {
                          conquista.pin_nome
                        }
                      </h3>

                      <strong>
                        {formatarDinheiro(
                          conquista
                            .volume_apurado
                        )}
                      </strong>

                      <small className="experienceCliente-collectionExperience">
                        {conquista
                          .experiencia_titulo
                          ? conquista
                              .experiencia_titulo
                          : "Experiência ainda não escolhida"}
                      </small>

                      {conquista.status ===
                        "AGUARDANDO_ESCOLHA" &&
                        !conquista.escolha_id && (
                          <button
                            type="button"
                            className="experienceCliente-chooseButton"
                            onClick={() =>
                              navigate(
                                `/painel-cliente/tikpag-experience/conquistas/${conquista.id}/escolher`
                              )
                            }
                          >
                            Escolher experiência
                          </button>
                      )}
                    </article>
                  )
                )}
              </div>
            ) : (
              <div className="experienceCliente-emptyCollection">
                <Trophy size={27} />

                <h3>
                  Sua coleção começa no primeiro
                  fechamento
                </h3>

                <p>
                  Continue cadastrando suas
                  operações para conquistar seu
                  primeiro PIN.
                </p>
              </div>
            )}
          </section>
        </>
      )}

      {regulamentoAberto && (
        <div
          className="experienceCliente-modalOverlay"
          onMouseDown={(event) => {
            if (
              event.target ===
              event.currentTarget
            ) {
              setRegulamentoAberto(
                false
              );
            }
          }}
        >
          <div className="experienceCliente-modal">
            <div className="experienceCliente-modalHeader">
              <div>
                <span className="experienceCliente-kicker dark">
                  Tikpag Experience
                </span>

                <h2>
                  Regulamento
                </h2>
              </div>

              <button
                type="button"
                onClick={() =>
                  setRegulamentoAberto(
                    false
                  )
                }
              >
                Fechar
              </button>
            </div>

            <div className="experienceCliente-modalBody">
              <p>
                {campanha.regulamento ||
                  "O regulamento desta campanha ainda não foi disponibilizado."}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}